import {
  setTrackingTokenInLocalStorage,
  getTrackingTokenFromLocalStorage,
} from 'helpers/browser';
import { get } from 'core_main/request';
import { TRACKING_TOKENS_CURRENT_ENDPOINT } from './constants';
import { TrackingTokensCurrentApiResponse } from './types';

let trackingTokenFetch;

export const fetchCurrentTrackingToken = () => {
  return get(TRACKING_TOKENS_CURRENT_ENDPOINT).then((response) => {
    const { token } = response.data.attributes;

    setTrackingTokenInLocalStorage(token);

    return response;
  });
};

export const maybeFetchCurrentTrackingToken =
  (): Promise<TrackingTokensCurrentApiResponse | void> => {
    const trackingToken = getTrackingTokenFromLocalStorage();

    if (trackingToken) return Promise.resolve();

    if (trackingTokenFetch) {
      return trackingTokenFetch;
    }

    trackingTokenFetch = fetchCurrentTrackingToken().then(() => {
      trackingTokenFetch = undefined;
    });

    return trackingTokenFetch;
  };
